import { useEffect } from 'react'
import { runDetached } from '@/shared/lib/runDetachedPromise'
import type { useAbandonSurvey } from '../api/survey-execution-mutations'

export function useSurveyBrowserAbandon(
  responseId: string | undefined,
  abandonMutation: ReturnType<typeof useAbandonSurvey>,
) {
  useEffect(() => {
    if (!responseId) return undefined
    const onBeforeUnload = () => {
      runDetached(abandonMutation.mutateAsync({ responseId, reason: 'browser_closed' }))
    }
    globalThis.addEventListener('beforeunload', onBeforeUnload)
    return () => globalThis.removeEventListener('beforeunload', onBeforeUnload)
  }, [abandonMutation, responseId])
}
